module.exports = __webpack_public_path__ + "img/ar_sa.7f438620.svg";